module.exports = __webpack_public_path__ + "static/assets/274c25f78da1a88c74564ac2ab978f95.png";